import React from "react";
import NotFoundContainer from "../components/etc/NotFoundContainer";

const NotFound = () => {
  return <NotFoundContainer />;
};

export default NotFound;
